import OnBoardingLayout from "../components/commons/layerTigo";
import Login from "../components/login";

export default function LogIn() {
  return <OnBoardingLayout screen={<Login />} withoutContainer={false} />;
}
